import React, { FunctionComponent } from 'react';
import { PlanProfile as PlanProfileDomain } from '../../../../logic/domains/planProfile.domain';
import Profile from '../Profile';
import withLoading from '../../../hoc/Loading';
import PlanProfileSummary from './PlanProfileSummary';
import PlanProfileHeader from './PlanProfileHeader';
import PlanProfileTabs from './PlanProfileTabs/PlanProfileTabs';
import EmployerDetails from './EmployerDetails';
import Tools from './Tools';

interface Props {
	planUUID: string;
	planProfile: PlanProfileDomain;
}

const PlanProfile: FunctionComponent<Props> = ({ planUUID, planProfile }) => {
	React.useEffect(() => {
		const firstBreadcrumb = document.querySelector('li.breadcrumb a');
		if (firstBreadcrumb) {
			// @ts-ignore
			firstBreadcrumb.focus();
		}
	}, []);
	return (
		<Profile
			header={<PlanProfileHeader planName={planProfile.planName} />}
			view={
				<>
					<PlanProfileSummary planProfile={planProfile} />
					<PlanProfileTabs planUUID={planUUID} planProfile={planProfile} />
				</>
			}
			details={<EmployerDetails employerDetails={planProfile.employer} />}
			tools={<Tools />}
		/>
	);
};

export default withLoading(PlanProfile);
